import { ofType } from 'redux-observable';
import { from, range, of } from 'rxjs';
import { mergeMap, flatMap, catchError, concat, map } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import { fetchOverviewSuccess } from 'signin-app/groups/actions';
import DayCareApi from 'signin-app/api/daycare-api';
import ChildrenEntity from 'signin-app/entities/children';
import StaffEntity from 'signin-app/entities/staff';
import * as AccountAPI from 'signin-app/account/api';
import * as AccountActions from 'signin-app/account/actions';
import * as Actions from './actions';
const prefetch = action$ => action$.pipe(ofType(Actions.prefetch.type), mergeMap(({ payload }) => DayCareApi.groups(payload.accessToken).pipe(flatMap((overview) => {
    const fetchAllGroupsObservable = range(0, overview.groups.length).pipe(flatMap(i => {
        return ChildrenEntity.observables.fetchAll({
            accessToken: payload.accessToken,
            groupId: overview.groups[i].groupId,
            institutionId: overview.institution && overview.institution.institutionId,
            includeRelations: true,
            id: overview.groups[i].groupId,
        }).pipe(flatMap((fetchChildrenSuccessActions) => from(fetchChildrenSuccessActions)));
    }));
    return StaffEntity.observables.fetchAll(payload.accessToken).pipe(flatMap((fetchStaffSuccessActions) => {
        return fetchAllGroupsObservable.pipe(concat(from(fetchStaffSuccessActions), of(fetchOverviewSuccess.action(overview)), of(Actions.prefetchSuccess.action())));
    }), catchError(e => of(Actions.prefetchFailed.action(e))));
}))));
const fetchAccount = action$ => action$.pipe(ofType(Actions.prefetchSuccess.type), mergeMap(() => {
    return AccountAPI.fetchAccount().pipe(map(AccountActions.fetchAccountSuccess.action));
}));
export default combineEpics(prefetch, fetchAccount);
